import { createSlice } from "@reduxjs/toolkit";

// THUNK: Login User
// export const loginUser = makeThunk({url: LOGIN});

const initialState = {
  loading: false,
  isLoading: false,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,

  extraReducers: (builder) => {
    // handleCommonCases(builder, loginUser, {
    //   onFulfilled: (state, action) => {},
    // });
  },
});

export default settingsSlice.reducer;
